export const REPORT_TYPES = {
  FOOTBALL: "Football",
  CONCERT: "Concert",
};

export const REPORTING_TYPE = {
  ownership: "ownership",
  duplicate: "duplicate",
  edit: "edit",
};

export const FOOTBALL_TYPES = {
  MEN: "Men's Football",
  WOMEN: "Women's Football",
  FRIENDLY: "Other Match",
  INTERNATIONAL:'International Match'
};

export const COMPETITION_TYPE = {
  friendly: "Friendly Match",
};

export const SECURITY_LEVELS = ["High", "Medium", "Low", "Club Security", "Police Free", "Police Free +", "Police Spotters Only"];

export const ARCHIVED_SEASONS = ["2015/2016","2016/2017", "2017/2018", "2018/2019", "2019/2020", "2020/2021", "2021/2022", "2022/2023","2023/2024"];


export const INTERNATIONAL_TEAMS = [
  { label: "England", value: "England" },
  { label: "Wales", value: "Wales" },
  { label: "Scotland", value: "Scotland" },
  { label: "Northern Ireland", value: "Northern Ireland" },
  { label: "England U21", value: "England U21" },
  { label: "Wales U21", value: "Wales U21" },
  { label: "Scotland U21", value: "Scotland U21" },
  { label: "Northern Ireland U21", value: "Northern Ireland U21" },
  { label: "England W", value: "England W" },
  { label: "Wales W", value: "Wales W" },
  { label: "Scotland W", value: "Scotland W" },
  { label: "Northern Ireland W", value: "Northern Ireland W" },
];

// International competitions options
export const INTERNATIONAL_COMPETITIONS = [
  { label: "Men's World Cup Qualifier", value: "Men's World Cup Qualifier" },
  { label: "Men's World Cup", value: "Men's World Cup" },
  { label: "Men's European Championship Qualifier", value: "Men's European Championship Qualifier" },
  { label: "Men's European Championship", value: "Men's European Championship" },
  { label: "Men's Nations League", value: "Men's Nations League" },
  { label: "Men's U21 European Championship Qualifier", value: "Men's U21 European Championship Qualifier" },
  { label: "Men's International Friendly", value: "Men's International Friendly" },
  { label: "Men's U21 International Friendly", value: "Men's U21 International Friendly" },
  { label: "Women's World Cup Qualifier", value: "Women's World Cup Qualifier" },
  { label: "Women's World Cup", value: "Women's World Cup" },
  { label: "Women's European Championship Qualifier", value: "Women's European Championship Qualifier" },
  { label: "Women's European Championship", value: "Women's European Championship" },
  { label: "Women's Nations League", value: "Women's Nations League" },
  { label: "Women's International Friendly", value: "Women's International Friendly" },
  { label: "Women's U21 International Friendly", value: "Women's U21 International Friendly" },
];
